module.exports = __webpack_public_path__ + "static/img/Jeremy-Cameron.b7cd702.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jeremy-Cameron.jpg
// module id = hqbe
// module chunks = 0